import styled from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global/stylings';

export const DescriptionContainer = styled.div<{ $isDesktop?: boolean }>`
  display: flex;
  justify-content: left;
  margin: 0;
  padding: 32px 24px 48px;
  padding: ${({ $isDesktop }) => ($isDesktop ? '32px 12px 39px' : '32px 24px 48px')};
  width: 100%;
`;

export const CategoryDescription = styled.p<{ $isPLP?: boolean }>`
  ${TypographyStyles.Body.Small.Regular}
  margin: 0;
  text-align: left;

  ${({ $isPLP }) =>
    !$isPLP &&
    `
    @media ${media.greaterThan('lg')} {
      margin: 0 ${spacing.L} 0 ${spacing.L};
    }
  `}
`;

export const HorizontalLine = styled.div<{ $isDesktop?: boolean }>`
  background-color: ${colours.BLACK};
  box-sizing: border-box;
  height: 1px;
  margin: ${({ $isDesktop }) => ($isDesktop ? '20px 0 0' : '12px 24px 0')};
`;
